export default __webpack_public_path__ + "static/media/league-bg.3c62ab33.png";